(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameDeleteController',SectorClinicNameDeleteController);

    SectorClinicNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorClinicName'];

    function SectorClinicNameDeleteController($uibModalInstance, entity, SectorClinicName) {
        var vm = this;
        vm.sectorClinicName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorClinicName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
